import React from 'react';
import classes from './NavigationItem.module.css';
import { NavLink } from 'react-router-dom';

const isExternal = (link) => /^https?:\/\//.test(link);
const isHashLink = (link) => link[1] === '#';

const NavigationItem = React.memo((props) => {
	const { link, children } = props;
	let finalAddress;

	if (isExternal(link)) {
		finalAddress = (
			<a href={link} target="_blank" rel="noopener noreferrer">
				{children}
			</a>
		);
	} else if (isHashLink(link)) {
		finalAddress = (
			<a href={link}>
				{children}
			</a>
		);
	} else {
		finalAddress = (
			<NavLink
				to={link}
				className={({ isActive }) => isActive ? classes.Selected : undefined}
			>
				{children}
			</NavLink>
		);
	}

	return <li className={classes.NavigationItem}>{finalAddress}</li>;
});


export default NavigationItem;
